import styled from 'styled-components';

export const PlannedMilestoneFooter = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1 !important;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  min-height: 50px;
`;

export const PlannedMilestoneFooterContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlannedMilestoneFooterText = styled.div`
  font-size: 16px;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PlannedMilestoneFooterActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const PlannedMilestoneFooterCancel = styled.button`
  background: #fff;
  border: 1px solid #bbb;
  color: #333;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition:
    background 0.2s,
    border 0.2s;
  &:hover {
    background: #f5f5f5;
    border-color: #888;
  }
`;

export const PlannedMilestoneFooterSave = styled.button`
  background: #2b7cff;
  border: none;
  color: #fff;
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
  &:hover {
    background: #1a5fcc;
  }
`;
